<template>
    <app-layout-main title="Media Library">

        <template v-slot:left-area>
            <div class="mb-5 p-2">
                <div class="search-wrapper">
                   <input class="input-black" type="text" placeholder="Search object...">
                   <i class="search"></i>
                </div>

                <ul class="categories">
                    <li v-for="cat in categories">
                        <div class="flex justify-between cursor-pointer">
                            <div class="flex icon-name items-center">
                                <i :class="cat.icon"></i>
                                <span>{{ cat.name }}</span>
                            </div>
                            <span class="number-wrapper">
                                <span class="number">{{ cat.count }}</span>
                            </span>
                        </div>
                    </li>
                </ul>

            </div>
        </template>

        <MediaLibraryGrid />
    </app-layout-main>
</template>

<script>
import AppLayoutMain from '@/Layouts/AppLayoutMain.vue'
import MediaLibraryGrid from '@/Pages/Media/MediaLibraryGrid.vue'
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        AppLayoutMain,
        MediaLibraryGrid,
        Link,
    },

    props: {
        locale: String,
    },
    data() {
        return {
            show: false,
            categories: [
                {
                    name: 'All',
                    icon: 'ricon-rooms',
                    count: 24,
                },
                {
                    name: 'JPG',
                    icon: 'images',
                    count: 12,
                },
                {
                    name: 'PNG',
                    icon: 'images',
                    count: 12,
                }
            ]
        }
    }
}
</script>
